import { render } from "./QuestionsList.vue?vue&type=template&id=0954dc6a"
import script from "./QuestionsList.vue?vue&type=script&lang=js"
export * from "./QuestionsList.vue?vue&type=script&lang=js"

import "./QuestionsList.vue?vue&type=style&index=0&id=0954dc6a&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__